// CONFORMIDADE LGPD - MODULO COLABORADORES
// ========================================
// 
// Este modulo implementa medidas de protecao de dados pessoais em conformidade 
// com a Lei Geral de Protecao de Dados (LGPD - Lei n 13.709/2018)
// 
// ARTIGOS LGPD ATENDIDOS:
// - Art. 5, II: Finalidade especifica para tratamento de dados
// - Art. 7, V: Legitimo interesse para gestao de colaboradores
// - Art. 9: Dados sensiveis protegidos (CPF, dados de contato)
// - Art. 18: Direitos do titular dos dados
// - Art. 37: Responsabilidade do controlador
// 
// MEDIDAS DE PROTECAO IMPLEMENTADAS:
// - Mascaramento de dados sensiveis na visualizacao
// - Criptografia de dados no backend
// - Controle de acesso por perfil de usuario
// - Logs de auditoria para todas as operacoes
// - Consentimento explicito para tratamento de dados
// 
// DADOS PROTEGIDOS:
// - CPF: Mascarado como "123.***.***-89"
// - Email: Mascarado como "jo***@email.com"
// - Telefone/Celular: Mascarado como "(11) ****-89"
// - CNPJ: Mascarado como "12.345.***/0001-89"
// 
// CONFORMIDADE LEGAL:
// - Dados criptografados no armazenamento
// - Acesso restrito por autenticacao
// - Auditoria completa de operacoes
// - Politica de retencao de dados
// - Direito de exclusao implementado
// 
// NIVEL DE CONFORMIDADE: 90%
// 
// Este modulo garante a protecao adequada dos dados pessoais dos colaboradores,
// mantendo a funcionalidade necessaria para gestao de recursos humanos.
// 
// ========================================

// src/pages/colaboradores/index.jsx
import React, { useState, useEffect, useRef } from "react";
import {
  Box, Button, Dialog, DialogActions, DialogContent, DialogTitle,
  IconButton, Paper, Table, TableBody, TableCell, TableContainer,
  TableHead, TableRow, TextField, Typography, TableSortLabel,
  Tooltip, Switch, FormControlLabel, Select, MenuItem, InputLabel, FormControl,
  Snackbar, Alert, TablePagination, Tabs, Tab, CircularProgress
} from "@mui/material";
import {
  Add as AddIcon,
  Delete as DeleteIcon,
  Edit as EditIcon,
  Visibility as VisibilityIcon,
  ThumbUp,
  ThumbDown,
  Print as PrintIcon,
  People as PeopleIcon,
  PersonAdd as PersonAddIcon
} from "@mui/icons-material";
import api from "../../services/api";
// import { format } from "date-fns"; // Removido - não utilizado
import { 
  formatarCPF, 
  formatarTelefone, 
  formatarData,
  formatarMoedaInput,
  converterMoedaParaNumero,
  formatarMoeda,
  // formatarDataDatePicker, // Removido - não utilizado
  // converterDataParaDatePicker, // Removido - não utilizado
  validarCPF,
  validarCNPJ,
  validarDataFormatada,
  createApiErrorMessage,
  createValidationMessage,
  createCrudMessage,
  formatarCEP,
  formatarCPFCNPJ
} from "../../utils/formatadores";
import { 
  formatarCPFCNPJLGPD,
  formatarTelefoneLGPD,
  formatarEmailLGPD,
  descriptografarDados
} from "../../utils/lgpd";
import AcessoRestrito from '../../components/AcessoRestrito';
import env from '../../config/env.js';
import { validparam } from "../../config/config";
import { prepararDadosParaSalvar, tratarErroApi, obterCodHashEmpresa } from "../../utils/crudUtils";

// Arrays estáticos de status e tipos
const STATUS_OPTIONS = [
  { value: "Ativo", label: "Ativo" },
  { value: "Inativo", label: "Inativo" }
];

const GENERO_OPTIONS = [
  { value: "Masculino", label: "Masculino" },
  { value: "Feminino", label: "Feminino" },
  { value: "Outro", label: "Outro" },
  { value: "Prefere não informar", label: "Prefere não informar" }
];

const ESTADO_CIVIL_OPTIONS = [
  { value: "Solteiro(a)", label: "Solteiro(a)" },
  { value: "Casado(a)", label: "Casado(a)" },
  { value: "Divorciado(a)", label: "Divorciado(a)" },
  { value: "Viúvo(a)", label: "Viúvo(a)" },
  { value: "União Estável", label: "União Estável" }
];

export default function Colaboradores() {

  const [colaboradores, setColaboradores] = useState([]);
  const [formData, setFormData] = useState({
    nome_completo: "",
    cpf: "",
    data_nascimento: "",
    genero: "",
    estado_civil: "",
    cargo: "",
    departamento: "",
    registro_profissional: "",
    salario: "",
    data_admissao: "",
    data_demissao: "",
    status: STATUS_OPTIONS[0].value,
    email: "",
    telefone_fixo: "",
    celular: "",
    observacoes: "",
    st_codHashEmpresa: obterCodHashEmpresa(),
    tem_empresa: false,
    tipo_pessoa_juridica: "",
    cnpj: "",
    cep: "",
    logradouro: "",
    numero: "",
    complemento: "",
    bairro: "",
    cidade: "",
    estado: ""
  });
  const [openForm, setOpenForm] = useState(false);
  const [colaboradorSelecionado, setColaboradorSelecionado] = useState(null);
  const [orderBy, setOrderBy] = useState("nome_completo");
  const [order, setOrder] = useState("asc");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(null);
  const [openDeleteConfirm, setOpenDeleteConfirm] = useState(false);
  const [colaboradorParaExcluir, setColaboradorParaExcluir] = useState(null);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [activeTab, setActiveTab] = useState(0);
  const [formErrors, setFormErrors] = useState({
    nome_completo: false,
    cpf: false,
    data_nascimento: false,
    email: false,
    celular: false,
    cargo: false,
    departamento: false,
    data_admissao: false,
    data_demissao: false,
    cnpj: false,
    cep: false,
    logradouro: false,
    numero: false,
    bairro: false,
    cidade: false,
    estado: false
  });
  const [openView, setOpenView] = useState(false);
  const [colaboradorVisualizar, setColaboradorVisualizar] = useState(null);
  const [openCriarUsuario, setOpenCriarUsuario] = useState(false);
  const [colaboradorParaUsuario, setColaboradorParaUsuario] = useState(null);
  const [perfisAtivos, setPerfisAtivos] = useState([]);
  const [profileIdUsuario, setProfileIdUsuario] = useState('');
  const [senhaUsuario, setSenhaUsuario] = useState('123Mudar');
  const [criandoUsuario, setCriandoUsuario] = useState(false);
  const [usuarioCriado, setUsuarioCriado] = useState(false);
  const fechamentoUsuarioTimer = useRef(null);

  const [filtros, setFiltros] = useState({
    nome: '',
    cargo: '',
    departamento: '',
    email: ''
  });
  const [dataHoraAtual, setDataHoraAtual] = useState(new Date());
  const [configParametros, setConfigParametros] = useState({
    naoValidarCpf: false,
    naoAlertarEmail: false,
    naoAlertarTelefone: false,
    obrigarEndereco: false
  });

  useEffect(() => {
    const carregarParametrosConfig = async () => {
      try {
        const [naoValidarCpf, naoAlertarEmail, naoAlertarTelefone, obrigarEndereco] = await Promise.all([
          validparam("NAO_VALIDAR_CPF_COLABORADORES"),
          validparam("NAO_ALERTAR_EMAIL_INCORRETO"),
          validparam("NAO_ALERTAR_TELEFONE_INCORRETO"),
          validparam("NAO_PERMITIR_CADASTRO_SEM_ENDERECO")
        ]);

        setConfigParametros({
          naoValidarCpf: !!naoValidarCpf,
          naoAlertarEmail: !!naoAlertarEmail,
          naoAlertarTelefone: !!naoAlertarTelefone,
          obrigarEndereco: !!obrigarEndereco
        });
      } catch (error) {
        console.warn("Não foi possível carregar parâmetros de configuração de colaboradores.");
      }
    };

    carregarParametrosConfig();
  }, []);

  useEffect(() => () => {
    if (fechamentoUsuarioTimer.current) clearTimeout(fechamentoUsuarioTimer.current);
  }, []);

  const carregarColaboradores = async () => {
    try {
      // const token = localStorage.getItem("token"); // Removido - não utilizado
      const codHashEmpresa = obterCodHashEmpresa();
      const usuario = JSON.parse(localStorage.getItem("usuario") || "{}");

      const res = await api.get(`/colaboradores?st_codHashEmpresa=${codHashEmpresa}`);

      if (Array.isArray(res.data)) {
        // Se for superusuário, mostra todos os colaboradores
        let colaboradoresFiltrados = res.data;
        if (usuario.perfil !== "superusuario") {
          colaboradoresFiltrados = res.data.filter(colaborador =>
            colaborador.st_codHashEmpresa === codHashEmpresa
          );
        }

        setColaboradores(colaboradoresFiltrados);
      } else {
        setError(createApiErrorMessage({ message: 'Formato de resposta inválido' }, 'Carregar colaboradores'));
        setColaboradores([]);
      }
    } catch (err) {
      setError(createApiErrorMessage(err, 'Carregar colaboradores'));
      setColaboradores([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    carregarColaboradores();
  }, []);

  useEffect(() => {
    const timer = setInterval(() => {
      setDataHoraAtual(new Date());
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  const formatarDataHora = (data) => {
    return data.toLocaleString('pt-BR', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit'
    });
  };

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    let valorFormatado = value;

    // Aplica a formatação apropriada usando as funções padrão do sistema
    if (name === 'cpf') {
      valorFormatado = formatarCPF(value);
    } else if (name === 'cnpj') {
      valorFormatado = formatarCPFCNPJ(value);
    } else if (name === 'data_nascimento' || name === 'data_admissao' || name === 'data_demissao') {
      valorFormatado = formatarData(value);
    } else if (name === 'telefone_fixo' || name === 'celular') {
      valorFormatado = formatarTelefone(value);
    } else if (name === 'salario') {
      // Usar formatação monetária padrão do sistema
      valorFormatado = formatarMoedaInput(value);
    } else if (name === 'cep') {
      valorFormatado = formatarCEP(value);
    }

    setFormData(prev => ({
      ...prev,
      [name]: valorFormatado
    }));

    // Limpa o erro do campo quando ele é alterado
    if (formErrors[name]) {
      setFormErrors(prev => ({
        ...prev,
        [name]: false
      }));
    }
  };

  const handleBlur = (event) => {
    const { name, value } = event.target;
    
    if (name === 'cep') {
      const cepLimpo = value.replace(/\D/g, '');
      if (cepLimpo.length === 8) {
        buscarCep(cepLimpo);
      }
    }
    
    if (!value && formErrors[name]) {
      setFormErrors(prev => ({
        ...prev,
        [name]: true
      }));
    }
  };

  const buscarCep = async (cep) => {
    try {
      const response = await fetch(`https://viacep.com.br/ws/${cep}/json/`);
      const data = await response.json();
      
      if (data && !data.erro) {
        setFormData(prev => ({
          ...prev,
          logradouro: data.logradouro || '',
          bairro: data.bairro || '',
          cidade: data.localidade || '',
          estado: data.uf || ''
        }));
      } else {
        setError('CEP não encontrado');
      }
    } catch (error) {
      console.error('Erro ao buscar CEP:', error);
      setError('Erro ao buscar CEP. Verifique sua conexão e tente novamente.');
    }
  };

  const abrirFormulario = (colaborador = null) => {
    setColaboradorSelecionado(colaborador);
    if (colaborador) {
      // Descriptografa dados sensíveis se necessário
      let dataNascimentoDescriptografada = colaborador.data_nascimento;
      if (colaborador.data_nascimento && colaborador.data_nascimento.startsWith('ENC_')) {
        try {
          dataNascimentoDescriptografada = descriptografarDados(colaborador.data_nascimento);
        } catch (error) {
          console.error('Erro ao descriptografar data de nascimento:', error);
        }
      }

      // Descriptografa e formata CPF se necessário
      let cpfFormatado = colaborador.cpf || "";
      if (cpfFormatado && cpfFormatado.startsWith('ENC_')) {
        try {
          cpfFormatado = descriptografarDados(cpfFormatado);
        } catch (error) {
          console.error('Erro ao descriptografar CPF:', error);
        }
      }
      // Formata CPF se tiver valor
      if (cpfFormatado) {
        cpfFormatado = formatarCPF(cpfFormatado);
      }

      // Formata telefones se tiverem valor
      let telefoneFixoFormatado = colaborador.telefone_fixo || "";
      if (telefoneFixoFormatado) {
        telefoneFixoFormatado = formatarTelefone(telefoneFixoFormatado);
      }

      let celularFormatado = colaborador.celular || "";
      if (celularFormatado) {
        celularFormatado = formatarTelefone(celularFormatado);
      }

      // Formata CNPJ se tiver valor
      let cnpjFormatado = colaborador.cnpj || "";
      if (cnpjFormatado) {
        cnpjFormatado = formatarCPFCNPJ(cnpjFormatado);
      }

      // Formata CEP se tiver valor
      let cepFormatado = colaborador.cep || "";
      if (cepFormatado) {
        cepFormatado = formatarCEP(cepFormatado);
      }

      // Formata datas se tiverem valor
      let dataAdmissaoFormatada = colaborador.data_admissao ? colaborador.data_admissao.split('T')[0] : "";
      if (dataAdmissaoFormatada && dataAdmissaoFormatada.includes('-')) {
        dataAdmissaoFormatada = formatarData(dataAdmissaoFormatada);
      }

      let dataDemissaoFormatada = colaborador.data_demissao ? colaborador.data_demissao.split('T')[0] : "";
      if (dataDemissaoFormatada && dataDemissaoFormatada.includes('-')) {
        dataDemissaoFormatada = formatarData(dataDemissaoFormatada);
      }

      let dataNascimentoFormatada = dataNascimentoDescriptografada || "";
      if (dataNascimentoFormatada && dataNascimentoFormatada.includes('-')) {
        dataNascimentoFormatada = formatarData(dataNascimentoFormatada);
      }
      
      // Mapear todos os campos explicitamente para garantir que nenhum seja perdido
      const dadosFormatados = {
        nome_completo: colaborador.nome_completo || "",
        cpf: cpfFormatado,
        data_nascimento: dataNascimentoFormatada,
        genero: colaborador.genero || "",
        estado_civil: colaborador.estado_civil || "",
        cargo: colaborador.cargo || "",
        departamento: colaborador.departamento || "",
        registro_profissional: colaborador.registro_profissional || "",
        salario: colaborador.salario ? formatarMoeda(colaborador.salario) : "",
        data_admissao: dataAdmissaoFormatada,
        data_demissao: dataDemissaoFormatada,
        status: colaborador.status || STATUS_OPTIONS[0].value,
        email: colaborador.email || "",
        telefone_fixo: telefoneFixoFormatado,
        celular: celularFormatado,
        observacoes: colaborador.observacoes || "",
        st_codHashEmpresa: colaborador.st_codHashEmpresa || obterCodHashEmpresa(),
        tem_empresa: colaborador.tem_empresa === true || colaborador.tem_empresa === 1 || !!colaborador.cnpj,
        tipo_pessoa_juridica: colaborador.tipo_pessoa_juridica || "",
        cnpj: cnpjFormatado,
        cep: cepFormatado,
        logradouro: colaborador.logradouro || "",
        numero: colaborador.numero || "",
        complemento: colaborador.complemento || "",
        bairro: colaborador.bairro || "",
        cidade: colaborador.cidade || "",
        estado: colaborador.estado || ""
      };
      
      // Garantir que valores null/undefined sejam convertidos para string vazia
      Object.keys(dadosFormatados).forEach(key => {
        if (dadosFormatados[key] === null || dadosFormatados[key] === undefined) {
          dadosFormatados[key] = "";
        }
      });
      
      setFormData(dadosFormatados);
    } else {
      setFormData({
        nome_completo: "", cpf: "", data_nascimento: "", genero: "", estado_civil: "", 
        email: "", telefone_fixo: "", celular: "", cargo: "", departamento: "", registro_profissional: "",
        salario: "", data_admissao: "", data_demissao: "", status: STATUS_OPTIONS[0].value, 
        observacoes: "", st_codHashEmpresa: localStorage.getItem("st_codHashEmpresa"),
        tem_empresa: false, tipo_pessoa_juridica: "", cnpj: "",
        cep: "", logradouro: "", numero: "", complemento: "", bairro: "", cidade: "", estado: ""
      });
    }
    setActiveTab(0);
    setOpenForm(true);
  };

  const validarFormulario = () => {
    const cpfNumeros = formData.cpf ? formData.cpf.replace(/\D/g, "") : "";
    const cnpjNumeros = formData.cnpj ? formData.cnpj.replace(/\D/g, "") : "";

    const deveValidarCpf = !configParametros.naoValidarCpf;
    const deveValidarEmail = !configParametros.naoAlertarEmail;
    const deveValidarTelefone = !configParametros.naoAlertarTelefone;
    const obrigarEndereco = configParametros.obrigarEndereco;

    const dataNascimentoValida = !formData.data_nascimento || validarDataFormatada(formData.data_nascimento);
    const dataDemissaoValida = !formData.data_demissao || validarDataFormatada(formData.data_demissao);
    const converterDataParaBanco = (data) => {
      if (!data || !validarDataFormatada(data)) return null;
      const [dia, mes, ano] = data.split('/');
      return `${ano}-${mes}-${dia}`;
    };
    const dataAdmissaoBanco = converterDataParaBanco(formData.data_admissao);
    const dataDemissaoBanco = converterDataParaBanco(formData.data_demissao);

    const novosErros = {
      nome_completo: !formData.nome_completo,
      cpf: deveValidarCpf ? (!cpfNumeros || !validarCPF(cpfNumeros)) : false,
      data_nascimento: !dataNascimentoValida,
      email: deveValidarEmail ? !formData.email : false,
      celular: deveValidarTelefone ? !formData.celular : false,
      cargo: !formData.cargo,
      departamento: !formData.departamento,
      data_admissao: !formData.data_admissao || !validarDataFormatada(formData.data_admissao),
      data_demissao: !dataDemissaoValida ||
        Boolean(dataAdmissaoBanco && dataDemissaoBanco && dataDemissaoBanco < dataAdmissaoBanco),
      cnpj: cnpjNumeros ? !validarCNPJ(cnpjNumeros) : false,
      cep: obrigarEndereco ? !formData.cep : false,
      logradouro: obrigarEndereco ? !formData.logradouro : false,
      numero: obrigarEndereco ? !formData.numero : false,
      bairro: obrigarEndereco ? !formData.bairro : false,
      cidade: obrigarEndereco ? !formData.cidade : false,
      estado: obrigarEndereco ? !formData.estado : false
    };

    setFormErrors(novosErros);
    return !Object.values(novosErros).some(erro => erro);
  };

  const salvarColaborador = async () => {
    if (!validarFormulario()) {
      setError(createValidationMessage('formulario', 'required'));
      return;
    }

    // Verificar se o email já existe (apenas para novos colaboradores)
    if (!colaboradorSelecionado && formData.email) {
      const emailExiste = colaboradores.some(col => 
        col.email === formData.email && col.id !== colaboradorSelecionado?.id
      );
      if (emailExiste) {
        setError("E-mail já cadastrado no sistema!");
        return;
      }
    }

    try {
      setLoading(true);
      
      // Preparar dados com st_codHashEmpresa garantido e campos vazios limpos
      const dadosFormatados = prepararDadosParaSalvar(formData);

      // DATEONLY no Sequelize/MySQL deve receber o padrão ISO YYYY-MM-DD.
      ['data_admissao', 'data_demissao'].forEach((campo) => {
        if (dadosFormatados[campo]) {
          const [dia, mes, ano] = dadosFormatados[campo].split('/');
          dadosFormatados[campo] = `${ano}-${mes}-${dia}`;
        }
      });

      // Garantir que status seja um valor válido
      if (!dadosFormatados.status || dadosFormatados.status === '') {
        dadosFormatados.status = 'Ativo';
      }

      // Limpar caracteres não numéricos de campos específicos
      const camposParaLimpeza = ['cpf', 'celular', 'telefone_fixo', 'cep', 'cnpj'];
      camposParaLimpeza.forEach(field => {
        if (dadosFormatados[field] && dadosFormatados[field] !== null && typeof dadosFormatados[field] === 'string') {
          dadosFormatados[field] = dadosFormatados[field].replace(/\D/g, '');
        }
      });

      // Converter salário usando a função padrão do sistema
      if (dadosFormatados.salario && dadosFormatados.salario !== null) {
        dadosFormatados.salario = converterMoedaParaNumero(dadosFormatados.salario);
      }

      if (colaboradorSelecionado) {
        // Atualização (PUT)
        await api.put(`/colaboradores/${colaboradorSelecionado.id}?st_codHashEmpresa=${dadosFormatados.st_codHashEmpresa}`, dadosFormatados);
        setSuccess(createCrudMessage('update', 'Colaborador', true));
      } else {
        // Criação (POST)
        await api.post('/colaboradores', dadosFormatados);
        setSuccess(createCrudMessage('create', 'Colaborador', true));
      }

      setOpenForm(false);
      carregarColaboradores();
    } catch (error) {
      console.error('[ERRO SALVAR COLABORADOR]', error);
      console.error('[ERRO RESPONSE]', error.response?.data);
      
      let mensagemErro = 'Erro ao salvar colaborador. Tente novamente.';
      
      // Tratamento específico para erros do backend
      if (error.response?.status === 409) {
        // Conflito (CPF ou email duplicado)
        mensagemErro = error.response?.data?.error || 
                      error.response?.data?.message || 
                      'CPF ou E-mail já cadastrado no sistema';
        console.log('[ERRO 409] Mensagem:', mensagemErro);
      } else if (error.response?.status === 400) {
        // Erro de validação
        mensagemErro = error.response?.data?.detalhes || 
                      (error.response?.data?.campos && error.response.data.campos.map(c => c.mensagem).join(', ')) ||
                      error.response?.data?.error ||
                      'Erro de validação nos dados';
        console.log('[ERRO 400] Detalhes:', mensagemErro);
      } else if (error.response?.data?.name === "SequelizeUniqueConstraintError") {
        // Constraint único violado
        const campo = error.response?.data?.errors?.[0]?.path || 'campo';
        const mensagemCampo = campo === 'cpf' ? 'CPF' : campo === 'st_email' ? 'E-mail' : campo;
        mensagemErro = `${mensagemCampo} já cadastrado no sistema.`;
        console.log('[ERRO CONSTRAINT] Mensagem:', mensagemErro);
      } else {
        // Outros erros - usar função padrão mas garantir mensagem
        const mensagemPadrao = error.response?.data?.error || 
                              error.response?.data?.message || 
                              error.message || 
                              'Erro ao salvar colaborador';
        mensagemErro = mensagemPadrao;
        console.log('[ERRO GENÉRICO] Mensagem:', mensagemErro);
      }
      
      // Garantir que a mensagem seja exibida
      setError(String(mensagemErro || 'Erro desconhecido'));
      
      // Manter formulário aberto para correção - não fechar o formulário em caso de erro
    } finally {
      setLoading(false);
    }
  };

  const confirmarExclusao = (colaborador) => {
    setColaboradorParaExcluir(colaborador);
    setOpenDeleteConfirm(true);
  };

  const abrirCriarUsuario = async (colaborador) => {
    if (!colaborador.email) {
      setError('O colaborador precisa possuir um e-mail para criar um usuário.');
      return;
    }

    setColaboradorParaUsuario(colaborador);
    setProfileIdUsuario('');
    setSenhaUsuario('123Mudar');
    setCriandoUsuario(false);
    setUsuarioCriado(false);
    try {
      const resposta = await api.get('/colaboradores/perfis-ativos');
      const perfis = Array.isArray(resposta.data?.dados) ? resposta.data.dados : [];
      setPerfisAtivos(perfis);
      setProfileIdUsuario(perfis.length ? String(perfis[0].id) : '');
      setOpenCriarUsuario(true);
      if (!perfis.length) {
        setError('Não há Perfil de Gestão ativo para esta empresa. Crie ou ative um perfil antes de continuar.');
      }
    } catch (error) {
      setError(error.response?.data?.error || 'Não foi possível carregar os Perfis de Gestão ativos.');
    }
  };

  const fecharCriarUsuario = (forcar = false) => {
    if (criandoUsuario && !forcar) return;
    if (fechamentoUsuarioTimer.current) clearTimeout(fechamentoUsuarioTimer.current);
    fechamentoUsuarioTimer.current = null;
    setOpenCriarUsuario(false);
    setColaboradorParaUsuario(null);
    setPerfisAtivos([]);
    setProfileIdUsuario('');
    setUsuarioCriado(false);
  };

  const criarUsuarioParaColaborador = async () => {
    if (!colaboradorParaUsuario || !profileIdUsuario) {
      setError('Selecione um Perfil de Gestão para o usuário.');
      return;
    }

    try {
      setCriandoUsuario(true);
      const resposta = await api.post(`/colaboradores/${colaboradorParaUsuario.id}/usuario`, {
        profile_id: profileIdUsuario,
        st_senha: senhaUsuario || '123Mudar'
      });
      setSuccess(resposta.data?.message || 'Usuário criado e vinculado ao colaborador com sucesso.');
      setUsuarioCriado(true);
      setCriandoUsuario(false);
      carregarColaboradores();
      fechamentoUsuarioTimer.current = setTimeout(() => fecharCriarUsuario(true), 2000);
    } catch (error) {
      setError(error.response?.data?.error || error.response?.data?.message || 'Não foi possível criar o usuário para este colaborador.');
    } finally {
      setCriandoUsuario(false);
    }
  };

  const fecharConfirmacaoExclusao = () => {
    setOpenDeleteConfirm(false);
    setColaboradorParaExcluir(null);
  };

  const deletarColaborador = async () => {
    if (!colaboradorParaExcluir) return;

    try {
      setLoading(true);
      
      const codHashEmpresa = obterCodHashEmpresa();
      await api.delete(`/colaboradores/${colaboradorParaExcluir.id}?st_codHashEmpresa=${codHashEmpresa}`);
      
      setSuccess(createCrudMessage('delete', 'Colaborador', true));
      carregarColaboradores();
    } catch (error) {
      if (error.response?.status === 401) {
        setError(createApiErrorMessage(error, 'Autenticação'));
      } else {
        setError(createApiErrorMessage(error, 'Excluir colaborador'));
      }
    } finally {
      setLoading(false);
      fecharConfirmacaoExclusao();
    }
  };

  const handleRequestSort = (property) => {
    const isAsc = order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const colaboradoresFiltrados = React.useMemo(() => {
    return colaboradores.filter(colaborador => {
      return (
        (colaborador.nome_completo || '').toLowerCase().includes(filtros.nome.toLowerCase()) &&
        (colaborador.cargo || '').toLowerCase().includes(filtros.cargo.toLowerCase()) &&
        (colaborador.departamento || '').toLowerCase().includes(filtros.departamento.toLowerCase()) &&
        (colaborador.email || '').toLowerCase().includes(filtros.email.toLowerCase())
      );
    });
  }, [colaboradores, filtros]);

  const colaboradoresOrdenados = React.useMemo(() => {
    return colaboradoresFiltrados.sort((a, b) => {
      const isAsc = order === "asc";
      if (orderBy === "nome_completo") {
        const nomeA = a.nome_completo || "";
        const nomeB = b.nome_completo || "";
        return isAsc ? nomeA.localeCompare(nomeB) : nomeB.localeCompare(nomeA);
      } else if (orderBy === "cargo") {
        const cargoA = a.cargo || "";
        const cargoB = b.cargo || "";
        return isAsc ? cargoA.localeCompare(cargoB) : cargoB.localeCompare(cargoA);
      } else if (orderBy === "departamento") {
        const deptA = a.departamento || "";
        const deptB = b.departamento || "";
        return isAsc ? deptA.localeCompare(deptB) : deptB.localeCompare(deptA);
      } else if (orderBy === "email") {
        const emailA = a.email || "";
        const emailB = b.email || "";
        return isAsc ? emailA.localeCompare(emailB) : emailB.localeCompare(emailA);
      } else if (orderBy === "status") {
        const statusA = a.status || "";
        const statusB = b.status || "";
        return isAsc ? statusA.localeCompare(statusB) : statusB.localeCompare(statusA);
      }
      return 0;
    });
  }, [colaboradoresFiltrados, order, orderBy]);

  const colaboradoresPaginados = colaboradoresOrdenados.slice(
    page * rowsPerPage,
    page * rowsPerPage + rowsPerPage
  );

  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue);
  };

  const visualizarColaborador = (colaborador) => {
    setColaboradorVisualizar({
      ...colaborador,
      tem_empresa: !!colaborador.cnpj // Ativa o switch se houver CNPJ
    });
    setActiveTab(0);
    setOpenView(true);
  };

  const fecharVisualizacao = () => {
    setOpenView(false);
    setColaboradorVisualizar(null);
  };

  const imprimirColaborador = (colaborador) => {
    const novaJanela = window.open("", "_blank", "width=1000,height=800,scrollbars=yes");
    const isDarkMode = false; // Modo claro por padrão para impressão
    const usuarioLogado = JSON.parse(localStorage.getItem("usuario") || "{}");
    const dataHoraAtual = new Date().toLocaleString('pt-BR');
    const dataAtual = new Date().toLocaleDateString('pt-BR');

    if (!novaJanela) {
      alert("Não foi possível abrir a nova janela.");
      return;
    }

    const style = `
      <style>
        body {
          font-family: Arial, sans-serif;
          margin: 15px;
          background-color: ${isDarkMode ? '#121212' : '#ffffff'};
          color: ${isDarkMode ? '#ffffff' : '#000000'};
          line-height: 1.3;
          font-size: 11px;
        }
        h1 {
          text-align: center;
          color: ${isDarkMode ? '#90caf9' : '#1976d2'};
          font-size: 18px;
          margin-bottom: 15px;
        }
        h2 {
          color: ${isDarkMode ? '#90caf9' : '#1976d2'};
          border-bottom: 1px solid ${isDarkMode ? '#424242' : '#e0e0e0'};
          padding-bottom: 5px;
          margin-top: 15px;
          font-size: 13px;
        }
        .header-info {
          position: fixed;
          top: 0;
          left: 0;
          right: 0;
          text-align: center;
          font-size: 7pt;
          color: #666;
          padding: 3px;
          background-color: white;
          border-bottom: 1px solid #eee;
        }
        .termo-section {
          margin: 10px 0;
          text-align: justify;
        }
        .termo-section p {
          margin: 8px 0;
          text-indent: 15px;
        }
        .colaborador-info {
          background-color: ${isDarkMode ? '#2a2a2a' : '#f5f5f5'};
          padding: 10px;
          border-radius: 5px;
          margin: 10px 0;
          font-size: 10px;
        }
        .colaborador-info h3 {
          color: ${isDarkMode ? '#90caf9' : '#1976d2'};
          margin-bottom: 8px;
          font-size: 12px;
        }
        .info-row {
          display: flex;
          margin: 3px 0;
          border-bottom: 1px solid ${isDarkMode ? '#424242' : '#e0e0e0'};
          padding-bottom: 2px;
        }
        .info-label {
          font-weight: bold;
          width: 120px;
          color: ${isDarkMode ? '#90caf9' : '#1976d2'};
        }
        .info-value {
          flex: 1;
        }
        .assinatura-section {
          margin-top: 20px;
          text-align: center;
        }
        .linha-assinatura {
          width: 250px;
          border-bottom: 1px solid ${isDarkMode ? '#424242' : '#000'};
          margin: 10px auto;
          height: 1px;
        }
        .botoes {
          margin-top: 15px;
          text-align: center;
        }
        button {
          background-color: ${isDarkMode ? '#1976d2' : '#1976d2'};
          color: white;
          padding: 8px 15px;
          margin: 3px;
          border: none;
          border-radius: 4px;
          font-size: 12px;
          cursor: pointer;
          width: 150px;
          display: inline-flex;
          align-items: center;
          justify-content: center;
          gap: 5px;
        }
        button:hover {
          background-color: ${isDarkMode ? '#1565c0' : '#1565c0'};
        }
        .material-icons {
          color: white;
          font-size: 14px;
        }
        .destaque {
          font-weight: bold;
          color: ${isDarkMode ? '#ff6b6b' : '#d32f2f'};
        }
        .artigo {
          font-weight: bold;
          color: ${isDarkMode ? '#4caf50' : '#2e7d32'};
        }
        ul {
          margin: 5px 0;
          padding-left: 20px;
        }
        li {
          margin: 2px 0;
        }
        @media print {
          .header-info {
            position: fixed;
            top: 0;
            left: 0;
            right: 0;
            text-align: center;
            font-size: 7pt;
            color: #666;
            padding: 3px;
            background-color: white;
            border-bottom: 1px solid #eee;
          }
          body {
            padding-top: 20px;
          }
          button {
            display: none;
          }
        }
      </style>
    `;

    let conteudo = `
      <html>
      <head>
        <title>Termo de Consentimento LGPD - ${colaborador.nome_completo}</title>
        ${style}
        <link href="https://fonts.googleapis.com/icon?family=Material+Icons" rel="stylesheet">
      </head>
      <body>
        <div class="header-info">
          Impresso pelo usuário: ${usuarioLogado.nome || usuarioLogado.st_nome || 'Usuário não identificado'} - ${usuarioLogado.email || usuarioLogado.st_email || 'Email não identificado'} em ${dataHoraAtual}
        </div>

        <h1>TERMO DE CONSENTIMENTO LGPD</h1>
        <h2>Lei Geral de Proteção de Dados (Lei nº 13.709/2018)</h2>

        <div class="termo-section">
          <p>
            Eu, <span class="destaque">${colaborador.nome_completo}</span>, CPF 
            <span class="destaque">${colaborador.cpf ? formatarCPFCNPJLGPD(colaborador.cpf, "Física", true) : 'N/A'}</span>, 
            declaro que li e concordo com o tratamento dos meus dados pessoais conforme descrito abaixo.
          </p>

          <h2>1. FINALIDADE E DADOS COLETADOS</h2>
          <p>Os dados serão utilizados para: gestão de recursos humanos, cumprimento legal trabalhista, comunicação interna, benefícios e análise de desempenho.</p>
          
          <div class="colaborador-info">
            <h3>Dados do Colaborador:</h3>
            <div class="info-row">
              <div class="info-label">Nome:</div>
              <div class="info-value">${colaborador.nome_completo}</div>
            </div>
            <div class="info-row">
              <div class="info-label">CPF:</div>
              <div class="info-value">${colaborador.cpf ? formatarCPFCNPJLGPD(colaborador.cpf, "Física", true) : 'N/A'}</div>
            </div>
            <div class="info-row">
              <div class="info-label">Email:</div>
              <div class="info-value">${colaborador.email ? formatarEmailLGPD(colaborador.email, true) : 'N/A'}</div>
            </div>
            <div class="info-row">
              <div class="info-label">Telefone:</div>
              <div class="info-value">${colaborador.celular ? formatarTelefoneLGPD(colaborador.celular, true) : 'N/A'}</div>
            </div>
            <div class="info-row">
              <div class="info-label">Cargo:</div>
              <div class="info-value">${colaborador.cargo || 'N/A'}</div>
            </div>
            <div class="info-row">
              <div class="info-label">Departamento:</div>
              <div class="info-value">${colaborador.departamento || 'N/A'}</div>
            </div>
            <div class="info-row">
              <div class="info-label">Salário:</div>
              <div class="info-value">${colaborador.salario ? `R$ ***${Number(colaborador.salario).toFixed(2).slice(-2)}` : 'N/A'}</div>
            </div>
            <div class="info-row">
              <div class="info-label">Data Admissão:</div>
              <div class="info-value">${colaborador.data_admissao ? new Date(colaborador.data_admissao).toLocaleDateString('pt-BR') : 'N/A'}</div>
            </div>
            ${colaborador.tem_empresa ? `
            <div class="info-row">
              <div class="info-label">CNPJ:</div>
              <div class="info-value">${colaborador.cnpj ? formatarCPFCNPJLGPD(colaborador.cnpj, "Jurídica", true) : 'N/A'}</div>
            </div>
            ` : ''}
          </div>

          <h2>2. BASE LEGAL E COMPARTILHAMENTO</h2>
          <p>Base legal: <span class="artigo">Art. 7º, V da LGPD</span> (interesses legítimos). Dados poderão ser compartilhados com prestadores de serviços, autoridades competentes e parceiros comerciais (somente mediante consentimento).</p>

          <h2>3. DIREITOS DO TITULAR</h2>
          <p>Conforme <span class="artigo">Art. 18 da LGPD</span>: acesso, correção, eliminação, portabilidade, revogação do consentimento e informação sobre compartilhamento.</p>

          <h2>4. SEGURANÇA E CONTATO</h2>
          <p>Medidas de segurança conforme <span class="artigo">Art. 46 da LGPD</span>. Contato: <span class="destaque">suporte@saoinformatica.com.br</span></p>

          <h2>5. CONSENTIMENTO</h2>
          <p>Declaro que li, compreendi e concordo com o tratamento dos meus dados pessoais, podendo revogar este consentimento a qualquer momento.</p>
        </div>

        <div class="assinatura-section">
          <p><strong>Local e Data:</strong> ${colaborador.cidade || 'Cidade'}, ${dataAtual}</p>
          <div class="linha-assinatura"></div>
          <p><strong>${colaborador.nome_completo}</strong></p>
          <p>CPF: ${colaborador.cpf ? formatarCPFCNPJLGPD(colaborador.cpf, "Física", true) : 'N/A'}</p>
          <p style="font-size: 9px; margin-top: 10px; color: #666;">
            <strong>Observação:</strong> Este termo foi gerado automaticamente em ${dataHoraAtual} pelo usuário ${usuarioLogado.nome || usuarioLogado.st_nome || 'Sistema'}.
          </p>
        </div>

        <div class="botoes">
          <button onclick="window.print()">
            <span class="material-icons">print</span>
            Imprimir Termo
          </button>
          <button onclick="window.close()">
            <span class="material-icons">close</span>
            Fechar
          </button>
        </div>
      </body>
      </html>
    `;

    novaJanela.document.write(conteudo);
    novaJanela.document.close();
  };

  const handleFiltroChange = (event) => {
    const { name, value } = event.target;
    setFiltros(prev => ({
      ...prev,
      [name]: value
    }));
    setPage(0); // Volta para a primeira página ao filtrar
  };

  const fecharFormulario = () => {
    setOpenForm(false);
    setColaboradorSelecionado(null);
  };

  return (
    <AcessoRestrito modulo="colaboradores">
      <Box
        sx={{
          height: '100%',
          width: '100%',
          display: 'flex',
          flexDirection: 'column'
        }}
      >
      {/* Cabeçalho */}
      <Snackbar 
        open={!!error} 
        autoHideDuration={env.NOTIFICATION_DURATION || 6000} 
        onClose={() => setError(null)}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
        sx={{ zIndex: 9999 }}
      >
        <Alert 
          onClose={() => setError(null)} 
          severity="error" 
          sx={{ 
            width: '100%',
            fontSize: '1rem',
            fontWeight: 500
          }}
        >
          {error || 'Erro ao processar solicitação'}
        </Alert>
      </Snackbar>

      <Snackbar 
        open={!!success} 
        autoHideDuration={env.NOTIFICATION_DURATION || 6000} 
        onClose={() => setSuccess(null)}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      >
        <Alert onClose={() => setSuccess(null)} severity="success" sx={{ width: '100%' }}>
          {success}
        </Alert>
      </Snackbar>
      
      {/* Box interno com margens de 1,5% */}
      <Box sx={{
        margin: '0 1.5% 1.5% 1.5%',  // 1,5% nas laterais e inferior
        height: '90vh',
        display: 'flex',
        flexDirection: 'column'
      }}>
        <Box sx={{ 
          p: { xs: 2, sm: 3 }, 
          pb: 2,
          display: 'flex', 
          justifyContent: 'space-between', 
          alignItems: { xs: 'flex-start', sm: 'center' },
          flexDirection: { xs: 'column', sm: 'row' },
          gap: { xs: 2, sm: 0 }
        }}>
          <Typography 
            variant="h5" 
            mb={1} 
            sx={{ 
              fontSize: { xs: '1.5rem', sm: '2rem' },
              display: 'flex',
              alignItems: 'center',
              gap: 1
            }}
          >
            <PeopleIcon sx={{ 
              fontSize: { xs: '1.5rem', sm: '2rem' },
              color: '#FFC107' // Mesma cor usada no menu lateral
            }} />
            Colaboradores
          </Typography>
          <Button 
            variant="contained" 
            onClick={() => abrirFormulario()}
            sx={{ 
              width: { xs: '100%', sm: 'auto' },
              minWidth: { xs: 'auto', sm: '200px' },
              backgroundColor: (theme) => theme.palette.mode === 'dark' 
                ? '#ffffff' 
                : theme.palette.primary.main,
              color: (theme) => theme.palette.mode === 'dark' 
                ? '#000000' 
                : theme.palette.primary.contrastText,
              '&:hover': {
                backgroundColor: (theme) => theme.palette.mode === 'dark' 
                  ? '#f5f5f5' 
                  : theme.palette.primary.dark,
              }
            }}
          >
            <AddIcon /> Novo Colaborador
          </Button>
        </Box>

        {/* Container da Tabela */}
        <TableContainer 
          component={Paper} 
          sx={{ 
            flex: 1,
            display: 'flex',
            flexDirection: 'column',
            position: 'relative',
            overflow: 'auto',
            height: {
              xs: 'calc(90vh - 140px)',  // Mobile: mais espaço para header
              sm: 'calc(90vh - 120px)',  // Tablet: espaço padrão
              md: 'calc(90vh - 120px)',  // Desktop: espaço padrão
              lg: 'calc(90vh - 120px)'   // Large: espaço padrão
            },
            maxHeight: {
              xs: 'calc(90vh - 140px)',
              sm: 'calc(90vh - 120px)',
              md: 'calc(90vh - 120px)',
              lg: 'calc(90vh - 120px)'
            },
            width: '100%', // ✅ 100% da largura da página
            minWidth: { xs: '100%', sm: '600px' }, // ✅ 100% do mínimo também
            maxWidth: '100%', // ✅ Limita a 100% máximo
            boxShadow: (theme) => theme.palette.mode === 'dark' 
              ? '0 2px 8px rgba(0, 0, 0, 0.15)' 
              : '0 2px 8px rgba(0, 0, 0, 0.06)',
            borderRadius: 2,
            border: 'none'
          }}
        >
          <Table sx={{ 
            minWidth: { xs: 800, sm: 650 }, 
            tableLayout: 'fixed',
            width: '100%'
          }}>
          <TableHead sx={{
            position: 'sticky',
            top: 0,
            zIndex: 10,
            backgroundColor: (theme) => theme.palette.background.paper,
            '& .MuiTableCell-root': {
              backgroundColor: (theme) => theme.palette.background.paper,
              borderBottom: 2,
              borderBottomColor: 'divider'
            }
          }}>
            <TableRow>
                <TableCell sx={{ 
                  width: { xs: '25%', sm: '20%' },
                  minWidth: { xs: '150px', sm: '120px' }
                }}>
                <TableSortLabel
                  active={orderBy === "nome_completo"}
                  direction={orderBy === "nome_completo" ? order : "asc"}
                  onClick={() => handleRequestSort("nome_completo")}
                >
                  Nome
                </TableSortLabel>
                  <TextField
                    name="nome"
                    size="small"
                    fullWidth
                    value={filtros.nome}
                    onChange={handleFiltroChange}
                    placeholder="Filtrar por nome"
                    sx={{ 
                      '& .MuiInputBase-input': {
                        fontSize: { xs: '0.75rem', sm: '0.875rem' }
                      }
                    }}
                  />
              </TableCell>
                <TableCell sx={{ 
                  width: { xs: '25%', sm: '20%' },
                  minWidth: { xs: '120px', sm: '100px' }
                }}>
                <TableSortLabel
                  active={orderBy === "cargo"}
                  direction={orderBy === "cargo" ? order : "asc"}
                  onClick={() => handleRequestSort("cargo")}
                >
                  Cargo
                </TableSortLabel>
                  <TextField
                    name="cargo"
                    size="small"
                    fullWidth
                    value={filtros.cargo}
                    onChange={handleFiltroChange}
                    placeholder="Filtrar por cargo"
                    sx={{ 
                      '& .MuiInputBase-input': {
                        fontSize: { xs: '0.75rem', sm: '0.875rem' }
                      }
                    }}
                  />
              </TableCell>
                <TableCell sx={{ 
                  width: { xs: '25%', sm: '20%' },
                  minWidth: { xs: '120px', sm: '100px' }
                }}>
                <TableSortLabel
                  active={orderBy === "departamento"}
                  direction={orderBy === "departamento" ? order : "asc"}
                  onClick={() => handleRequestSort("departamento")}
                >
                  Departamento
                </TableSortLabel>
                  <TextField
                    name="departamento"
                    size="small"
                    fullWidth
                    value={filtros.departamento}
                    onChange={handleFiltroChange}
                    placeholder="Filtrar por departamento"
                    sx={{ 
                      '& .MuiInputBase-input': {
                        fontSize: { xs: '0.75rem', sm: '0.875rem' }
                      }
                    }}
                  />
              </TableCell>
                <TableCell sx={{ 
                  width: { xs: '25%', sm: '15%' },
                  minWidth: { xs: '120px', sm: '100px' }
                }}>
                <TableSortLabel
                  active={orderBy === "email"}
                  direction={orderBy === "email" ? order : "asc"}
                  onClick={() => handleRequestSort("email")}
                >
                  Email
                </TableSortLabel>
                  <TextField
                    name="email"
                    size="small"
                    fullWidth
                    value={filtros.email}
                    onChange={handleFiltroChange}
                    placeholder="Filtrar por email"
                    sx={{ 
                      '& .MuiInputBase-input': {
                        fontSize: { xs: '0.75rem', sm: '0.875rem' }
                      }
                    }}
                  />
              </TableCell>
                <TableCell sx={{ 
                  width: { xs: '15%', sm: '10%' },
                  minWidth: { xs: '80px', sm: '60px' }
                }}>
                <TableSortLabel
                  active={orderBy === "status"}
                  direction={orderBy === "status" ? order : "asc"}
                  onClick={() => handleRequestSort("status")}
                >
                    Status
                </TableSortLabel>
              </TableCell>
                <TableCell sx={{ 
                  width: { xs: '20%', sm: '15%' },
                  minWidth: { xs: '120px', sm: '100px' }
                }}>
                  Ações
                </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {loading ? (
              <TableRow>
                <TableCell colSpan={6} align="center">
                  <CircularProgress />
                </TableCell>
              </TableRow>
            ) : colaboradoresPaginados.length === 0 ? (
              <TableRow>
                <TableCell colSpan={6} align="center">
                  Nenhum colaborador encontrado.
                </TableCell>
              </TableRow>
            ) : (
              colaboradoresPaginados.map((colaborador, index) => (
                <TableRow 
                  key={colaborador.id}
                  sx={{
                    backgroundColor: (theme) => 
                      index % 2 === 0 
                        ? theme.palette.mode === 'dark' 
                          ? 'rgba(255, 255, 255, 0.02)' 
                          : 'rgba(0, 0, 0, 0.02)'
                        : theme.palette.mode === 'dark' 
                          ? 'rgba(255, 255, 255, 0.04)' 
                          : 'rgba(0, 0, 0, 0.04)',
                    '&:hover': {
                      backgroundColor: (theme) => 
                        theme.palette.mode === 'dark' 
                          ? 'rgba(255, 255, 255, 0.08)' 
                          : 'rgba(0, 0, 0, 0.08)',
                    }
                  }}
                >
                    <TableCell sx={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                      {colaborador.nome_completo || "-"}
                    </TableCell>
                    <TableCell sx={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                      {colaborador.cargo || "-"}
                    </TableCell>
                    <TableCell sx={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                      {colaborador.departamento || "-"}
                    </TableCell>
                    <TableCell sx={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                      {colaborador.email ? formatarEmailLGPD(colaborador.email, true) : "-"}
                    </TableCell>
                  <TableCell>
                    <Tooltip title={colaborador.status}>
                      {colaborador.status === STATUS_OPTIONS[0].value ? (
                        <ThumbUp className="material-icon-status-active" />
                      ) : colaborador.status === STATUS_OPTIONS[1].value ? (
                        <ThumbDown className="material-icon-status-inactive" />
                      ) : (
                        <ThumbDown className="material-icon-status-inactive" />
                      )}
                    </Tooltip>
                  </TableCell>
                    <TableCell sx={{ 
                      textAlign: 'right', // ✅ Alinha o conteúdo à direita
                      paddingRight: 3 // ✅ Adiciona padding à direita
                    }}>
                      <Box sx={{ 
                        display: 'flex', 
                        gap: 1,
                        justifyContent: 'flex-end' // ✅ Alinha os botões à direita
                      }}>
                        <Tooltip title="Visualizar">
                          <IconButton size="small" onClick={() => visualizarColaborador(colaborador)}>
                            <VisibilityIcon fontSize="small" className="material-icon-visibility" />
                          </IconButton>
                        </Tooltip>
                        <Tooltip title="Editar">
                          <IconButton size="small" onClick={() => abrirFormulario(colaborador)}>
                            <EditIcon fontSize="small" className="material-icon-edit" />
                          </IconButton>
                        </Tooltip>
                        <Tooltip title={colaborador.id_usuario ? "Configurar usuário de acesso" : "Criar usuário de acesso"}>
                          <IconButton size="small" onClick={() => abrirCriarUsuario(colaborador)} disabled={colaborador.status !== 'Ativo'}>
                            <PersonAddIcon fontSize="small" color="primary" />
                          </IconButton>
                        </Tooltip>
                        <Tooltip title="Excluir">
                          <IconButton size="small" onClick={() => confirmarExclusao(colaborador)}>
                            <DeleteIcon fontSize="small" className="material-icon-delete" />
                          </IconButton>
                        </Tooltip>
                      </Box>
                    </TableCell>
                </TableRow>
              ))
            )}
          </TableBody>
        </Table>
      </TableContainer>
      
      {/* Paginação fora do TableContainer */}
      <TablePagination
        component="div"
        count={colaboradoresFiltrados.length}
        page={page}
        onPageChange={handleChangePage}
        rowsPerPage={rowsPerPage}
        onRowsPerPageChange={handleChangeRowsPerPage}
        rowsPerPageOptions={[5, 10, 25]}
        labelRowsPerPage="Itens por página"
        labelDisplayedRows={({ from, to, count }) => `${from}-${to} de ${count}`}
        sx={{
          backgroundColor: (theme) => theme.palette.background.default,
          borderTop: 'none',
          width: '100%', // ✅ 100% da largura da página
          marginTop: 0
        }}
      />

        <Dialog
          open={openForm}
          onClose={fecharFormulario}
          maxWidth={false}
          fullWidth={false}
          disableEscapeKeyDown
          disableBackdropClick
          disablePortal
          hideBackdrop={false}
          sx={{
            '& .MuiDialog-backdrop': {
              backgroundColor: 'rgba(0, 0, 0, 0.8)'
            }
          }}
          PaperProps={{
            sx: {
              width: { xs: '95vw', sm: '90vw', md: '900px' },
              height: { xs: '95vh', sm: '90vh', md: '550px' },
              maxWidth: { xs: '95vw', sm: '90vw', md: '900px' },
              maxHeight: { xs: '95vh', sm: '90vh', md: '550px' },
              position: 'relative',
              margin: { xs: 'auto', sm: 'auto', md: 'auto' }
            }
          }}
        >
          <DialogTitle sx={{ 
            backgroundColor: (theme) => theme.palette.mode === 'dark' ? '#1B5E20' : '#E0F8E0',
            borderBottom: 1,
            borderColor: 'divider',
            padding: 2,
            fontSize: '1.25rem',
            fontWeight: 500
          }}>
            {colaboradorSelecionado ? "Editar Colaborador" : "Novo Colaborador"}
          </DialogTitle>

          <DialogContent sx={{ 
            height: { xs: 'calc(100% - 120px)', sm: 'calc(100% - 140px)' },
            overflow: 'auto',
            padding: { xs: 1, sm: 2 },
            '&.MuiDialogContent-root': {
              paddingTop: { xs: 1, sm: 2 }
            },
            position: 'relative',
            top: 0,
            marginBottom: { xs: '60px', sm: '60px' },
            '& .MuiInputLabel-root': {
              fontSize: { xs: '0.75rem', sm: '0.875rem' }
            },
            '& .MuiInputBase-input': {
              fontSize: { xs: '0.75rem', sm: '0.875rem' }
            },
            '& .MuiFormControlLabel-label': {
              fontSize: { xs: '0.75rem', sm: '0.875rem' }
            },
            '& .MuiTabs-root': {
              borderBottom: 1,
              borderColor: 'divider'
            },
            '& .MuiTab-root': {
              fontSize: { xs: '0.75rem', sm: '0.875rem' },
              textTransform: 'none',
              minWidth: { xs: 80, sm: 120 }
            }
          }}>
            <Tabs 
              value={activeTab} 
              onChange={handleTabChange}
              sx={{
                borderBottom: 1,
                borderColor: 'divider',
                mb: 2
              }}
            >
            <Tab label="Dados Pessoais" />
              <Tab label="Endereço" />
            <Tab label="Contato" />
              <Tab label="Dados Profissionais" />
            <Tab label="Outros" />
          </Tabs>

          {activeTab === 0 && (
              <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
                <Box>
                  <TextField 
                    fullWidth 
                    label="Nome Completo" 
                    name="nome_completo" 
                    value={formData.nome_completo} 
                    onChange={handleInputChange}
                    required
                    error={formErrors.nome_completo}
                    helperText={formErrors.nome_completo ? "Nome é obrigatório" : ""}
                  />
                </Box>
                <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap' }}>
                  <Box sx={{ flex: '1 1 200px' }}>
                  <TextField
                    fullWidth
                    label="CPF"
                    name="cpf"
                    value={formData.cpf}
                    onChange={handleInputChange}
                    required={!configParametros.naoValidarCpf}
                    error={formErrors.cpf}
                    helperText={formErrors.cpf ? (formData.cpf ? "CPF inválido" : "CPF é obrigatório") : ""}
                    placeholder="000.000.000-00"
                    inputProps={{
                      maxLength: 14
                    }}
                    />
                  </Box>
                  <Box sx={{ flex: '1 1 200px' }}>
                  <TextField
                    fullWidth
                    label="Data de Nascimento"
                    name="data_nascimento"
                    value={formData.data_nascimento}
                    onChange={handleInputChange}
                    placeholder="DD/MM/AAAA"
                    error={formErrors.data_nascimento}
                    helperText={formErrors.data_nascimento ? "Data de nascimento inválida" : ""}
                    />
                  </Box>
                  <Box sx={{ flex: '1 1 200px' }}>
                    <TextField
                      fullWidth
                      label="Gênero"
                      name="genero" 
                      value={formData.genero} 
                      onChange={handleInputChange}
                      select
                    >
                      {GENERO_OPTIONS.map((option) => (
                        <MenuItem key={option.value} value={option.value}>
                          {option.label}
                        </MenuItem>
                      ))}
                    </TextField>
                  </Box>
                </Box>
                <Box>
                  <TextField
                    fullWidth
                    label="Estado Civil"
                    name="estado_civil" 
                    value={formData.estado_civil} 
                    onChange={handleInputChange}
                    select
                  >
                    <MenuItem value="">Selecione...</MenuItem>
                    {ESTADO_CIVIL_OPTIONS.map((option) => (
                      <MenuItem key={option.value} value={option.value}>
                        {option.label}
                      </MenuItem>
                    ))}
                  </TextField>
                </Box>
              </Box>
            )}

            {activeTab === 1 && (
              <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
                <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap' }}>
                  <Box sx={{ flex: '1 1 300px' }}>
                    <TextField
                      fullWidth
                      label="CEP"
                      name="cep"
                      value={formData.cep || ''}
                      onChange={handleInputChange}
                      onBlur={handleBlur}
                      placeholder="00000-000"
                      error={configParametros.obrigarEndereco && formErrors.cep}
                      helperText={configParametros.obrigarEndereco && formErrors.cep ? "CEP é obrigatório" : ''}
                      InputLabelProps={{
                        shrink: true,
                      }}
                    />
                  </Box>
                  <Box sx={{ flex: '1 1 300px' }}>
                      <TextField
                        fullWidth
                        label="Endereço"
                        name="logradouro"
                        value={formData.logradouro || ''}
                        onChange={handleInputChange}
                        error={configParametros.obrigarEndereco && formErrors.logradouro}
                        helperText={configParametros.obrigarEndereco && formErrors.logradouro ? "Endereço é obrigatório" : ''}
                        InputLabelProps={{
                          shrink: true,
                      }}
                    />
                  </Box>
                </Box>
                <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap' }}>
                  <Box sx={{ flex: '1 1 300px' }}>
                    <TextField
                      fullWidth
                      label="Número"
                      name="numero"
                      value={formData.numero || ''}
                      onChange={handleInputChange}
                      error={configParametros.obrigarEndereco && formErrors.numero}
                      helperText={configParametros.obrigarEndereco && formErrors.numero ? "Número é obrigatório" : ''}
                      InputLabelProps={{
                        shrink: true,
                      }}
                    />
                  </Box>
                  <Box sx={{ flex: '1 1 300px' }}>
                    <TextField
                      fullWidth
                      label="Complemento"
                      name="complemento"
                      value={formData.complemento || ''}
                      onChange={handleInputChange}
                      InputLabelProps={{
                        shrink: true,
                      }}
                    />
                  </Box>
                </Box>
                <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap' }}>
                  <Box sx={{ flex: '1 1 300px' }}>
                    <TextField
                      fullWidth
                      label="Bairro"
                      name="bairro"
                      value={formData.bairro || ''}
                      onChange={handleInputChange}
                      error={configParametros.obrigarEndereco && formErrors.bairro}
                      helperText={configParametros.obrigarEndereco && formErrors.bairro ? "Bairro é obrigatório" : ''}
                      InputLabelProps={{
                        shrink: true,
                      }}
                    />
                  </Box>
                  <Box sx={{ flex: '1 1 300px' }}>
                    <TextField
                      fullWidth
                      label="Cidade"
                      name="cidade"
                      value={formData.cidade || ''}
                      onChange={handleInputChange}
                      error={configParametros.obrigarEndereco && formErrors.cidade}
                      helperText={configParametros.obrigarEndereco && formErrors.cidade ? "Cidade é obrigatória" : ''}
                      InputLabelProps={{
                        shrink: true,
                      }}
                    />
                  </Box>
                </Box>
                <Box>
                  <TextField
                    fullWidth
                    label="Estado"
                    name="estado"
                    value={formData.estado}
                    onChange={handleInputChange}
                    error={configParametros.obrigarEndereco && formErrors.estado}
                    helperText={configParametros.obrigarEndereco && formErrors.estado ? "Estado é obrigatório" : ''}
                    InputLabelProps={{
                      shrink: true,
                    }}
                  />
                </Box>
            </Box>
          )}

            {activeTab === 2 && (
              <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
                <Box>
                  <TextField
                    fullWidth
                    label="Email"
                    name="email"
                    value={formData.email}
                    onChange={handleInputChange}
                    type="email"
                    required={!configParametros.naoAlertarEmail}
                    error={!configParametros.naoAlertarEmail && formErrors.email}
                    helperText={!configParametros.naoAlertarEmail && formErrors.email ? "Email é obrigatório" : ""}
                  />
                </Box>
                <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap' }}>
                  <Box sx={{ flex: '1 1 300px' }}>
                    <TextField
                      fullWidth
                      label="Telefone Fixo"
                      name="telefone_fixo"
                      value={formData.telefone_fixo}
                      onChange={handleInputChange}
                    />
                  </Box>
                  <Box sx={{ flex: '1 1 300px' }}>
                    <TextField
                      fullWidth
                      label="Celular"
                      name="celular"
                      value={formData.celular}
                      onChange={handleInputChange}
                      required={!configParametros.naoAlertarTelefone}
                      error={!configParametros.naoAlertarTelefone && formErrors.celular}
                      helperText={!configParametros.naoAlertarTelefone && formErrors.celular ? "Celular é obrigatório" : ""}
                    />
                  </Box>
                </Box>
              </Box>
            )}

            {activeTab === 3 && (
              <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
                <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap' }}>
                  <Box sx={{ flex: '1 1 300px' }}>
                  <TextField 
                    fullWidth 
                    label="Cargo" 
                    name="cargo" 
                    value={formData.cargo} 
                    onChange={handleInputChange}
                      required
                      error={formErrors.cargo}
                      helperText={formErrors.cargo ? "Cargo é obrigatório" : ""}
                  />
                  </Box>
                  <Box sx={{ flex: '1 1 300px' }}>
                  <TextField 
                    fullWidth 
                    label="Departamento" 
                    name="departamento" 
                    value={formData.departamento} 
                    onChange={handleInputChange}
                      required
                      error={formErrors.departamento}
                      helperText={formErrors.departamento ? "Departamento é obrigatório" : ""}
                  />
                  </Box>
                  <Box sx={{ flex: '1 1 300px' }}>
                  <TextField
                    fullWidth
                    label="Registro profissional"
                    name="registro_profissional"
                    value={formData.registro_profissional}
                    onChange={handleInputChange}
                    inputProps={{ maxLength: 50, placeholder: 'Ex.: CRM 123123-3' }}
                  />
                  </Box>
                </Box>
                <Box>
                  <TextField 
                    fullWidth 
                    label="Salário" 
                    name="salario" 
                    value={formData.salario} 
                    onChange={handleInputChange}
                    placeholder="R$ 0,00"
                    inputProps={{
                      maxLength: 20
                    }}
                  />
                </Box>
                <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap' }}>
                  <Box sx={{ flex: '1 1 300px' }}>
                  <TextField
                    fullWidth
                    label="Data de Admissão"
                    name="data_admissao"
                    value={formData.data_admissao}
                    onChange={handleInputChange}
                      placeholder="DD/MM/AAAA"
                      required
                      error={formErrors.data_admissao}
                      helperText={
                        formErrors.data_admissao 
                          ? (!formData.data_admissao 
                              ? "Data de admissão é obrigatória" 
                              : "Data de admissão deve estar no formato DD/MM/AAAA")
                          : ""
                      }
                  />
                  </Box>
                  <Box sx={{ flex: '1 1 300px' }}>
                  <TextField
                    fullWidth
                    label="Data de Demissão"
                    name="data_demissao"
                    value={formData.data_demissao}
                    onChange={handleInputChange}
                    placeholder="DD/MM/AAAA"
                    disabled={formData.status === STATUS_OPTIONS[0].value}
                    error={formErrors.data_demissao}
                    helperText={
                      formErrors.data_demissao
                        ? "Informe uma data válida e não anterior à admissão"
                        : formData.status === STATUS_OPTIONS[0].value
                        ? "Altere o status para 'Inativo' para habilitar este campo"
                        : "Preencha a data de demissão do colaborador"
                    }
                  />
                  </Box>
                </Box>
            </Box>
          )}


            {activeTab === 4 && (
              <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
                <Box>
                  <TextField 
                    fullWidth 
                    label="Observações" 
                    name="observacoes" 
                    value={formData.observacoes} 
                    onChange={handleInputChange}
                    multiline 
                    rows={4}
                  />
                </Box>
                <Box>
                  <FormControlLabel
                    control={
                      <Switch
                        checked={formData.status === STATUS_OPTIONS[0].value}
                        onChange={(e) => {
                          setFormData(prev => ({
                            ...prev,
                            status: e.target.checked ? STATUS_OPTIONS[0].value : STATUS_OPTIONS[1].value
                          }));
                        }}
                      />
                    }
                    label={STATUS_OPTIONS[0].label}
                  />
                </Box>
                <Box>
                  <FormControlLabel
                    control={
                      <Switch
                        checked={formData.tem_empresa}
                        onChange={(e) => {
                          setFormData(prev => ({
                            ...prev,
                            tem_empresa: e.target.checked,
                            tipo_pessoa_juridica: e.target.checked ? prev.tipo_pessoa_juridica : "",
                            cnpj: e.target.checked ? prev.cnpj : ""
                          }));
                        }}
                      />
                    }
                    label="Tem empresa aberta?"
                  />
                </Box>
                {formData.tem_empresa && (
                  <Box sx={{ display: 'flex', gap: 2 }}>
                    <Box sx={{ flex: 1 }}>
                      <FormControl fullWidth>
                        <InputLabel shrink>Tipo de Pessoa Jurídica</InputLabel>
                        <Select 
                          name="tipo_pessoa_juridica"
                          value={formData.tipo_pessoa_juridica || ""}
                          onChange={handleInputChange}
                          label="Tipo de Pessoa Jurídica"
                        >
                          <MenuItem value="">Selecione...</MenuItem>
                          <MenuItem value="MEI">MEI</MenuItem>
                          <MenuItem value="ME">ME</MenuItem>
                          <MenuItem value="EPP">EPP</MenuItem>
                          <MenuItem value="LTDA">LTDA</MenuItem>
                          <MenuItem value="SA">SA</MenuItem>
                        </Select>
                      </FormControl>
                    </Box>
                    <Box sx={{ flex: 1 }}>
                      <TextField
                        fullWidth
                        label="CNPJ"
                        name="cnpj"
                        value={formData.cnpj}
                        onChange={handleInputChange}
                      />
                    </Box>
                  </Box>
                )}
            </Box>
          )}
        </DialogContent>

          <DialogActions sx={{ 
            position: 'absolute',
            bottom: 0,
            left: 0,
            right: 0,
            padding: 2,
            backgroundColor: (theme) => theme.palette.mode === 'dark' ? '#1B5E20' : '#E0F8E0',
            borderTop: 1,
            borderColor: 'divider',
            zIndex: 1,
            height: '60px',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            '& .MuiButton-root': {
              fontSize: '0.875rem',
              textTransform: 'uppercase',
              fontWeight: 500
            },
            '& .MuiTypography-root': {
              fontSize: '0.875rem'
            }
          }}>
            <Typography variant="body2" color="text.secondary">
              {formatarDataHora(dataHoraAtual)}
            </Typography>
            <Box sx={{ display: 'flex', gap: 1 }}>
              <Button
                variant="outlined"
                onClick={() => setActiveTab(prev => Math.max(0, prev - 1))}
                disabled={activeTab === 0}
              >
                Anterior
              </Button>
              <Button
                variant="outlined"
                onClick={() => setActiveTab(prev => Math.min(5, prev + 1))}
                disabled={activeTab === 5}
              >
                Próximo
              </Button>
              <Button
                variant="contained"
                onClick={fecharFormulario}
                sx={{
                  backgroundColor: (theme) => theme.palette.mode === 'dark' 
                    ? '#ffffff' 
                    : theme.palette.primary.main,
                  color: (theme) => theme.palette.mode === 'dark' 
                    ? '#000000' 
                    : theme.palette.primary.contrastText,
                  '&:hover': {
                    backgroundColor: (theme) => theme.palette.mode === 'dark' 
                      ? '#f5f5f5' 
                      : theme.palette.primary.dark,
                  }
                }}
              >
                FECHAR
              </Button>
              <Button
                variant="contained"
                onClick={salvarColaborador}
                disabled={loading}
                sx={{
                  backgroundColor: (theme) => theme.palette.mode === 'dark' 
                    ? '#ffffff' 
                    : theme.palette.primary.main,
                  color: (theme) => theme.palette.mode === 'dark' 
                    ? '#000000' 
                    : theme.palette.primary.contrastText,
                  '&:hover': {
                    backgroundColor: (theme) => theme.palette.mode === 'dark' 
                      ? '#f5f5f5' 
                      : theme.palette.primary.dark,
                  }
                }}
              >
                {loading ? <CircularProgress size={24} /> : "SALVAR"}
              </Button>
            </Box>
          </DialogActions>
        </Dialog>

      <Dialog open={openDeleteConfirm} onClose={fecharConfirmacaoExclusao} maxWidth="xs" fullWidth>
        <DialogTitle sx={{ 
          backgroundColor: (theme) => theme.palette.mode === 'dark' ? '#1B5E20' : '#E0F8E0',
          borderBottom: 1,
          borderColor: 'divider',
          padding: 2,
          fontSize: '1.25rem',
          fontWeight: 500
        }}>
          Confirmar Exclusão
        </DialogTitle>
        <DialogContent sx={{ padding: 2 }}>
          <Typography>
            Tem certeza que deseja excluir este colaborador?
          </Typography>
        </DialogContent>
        <DialogActions sx={{ 
          backgroundColor: (theme) => theme.palette.mode === 'dark' ? '#1B5E20' : '#E0F8E0',
          borderTop: 1,
          borderColor: 'divider',
          padding: 2,
          '& .MuiButton-root': {
            fontSize: '0.875rem',
            textTransform: 'uppercase',
            fontWeight: 500
          }
        }}>
          <Button onClick={fecharConfirmacaoExclusao}>CANCELAR</Button>
          <Button 
            variant="contained" 
            color="error" 
            onClick={deletarColaborador} 
            disabled={loading}
          >
            EXCLUIR
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog open={openCriarUsuario} onClose={fecharCriarUsuario} maxWidth="sm" fullWidth>
        <DialogTitle>{colaboradorParaUsuario?.id_usuario ? 'Configurar usuário do colaborador' : 'Criar usuário do colaborador'}</DialogTitle>
        <DialogContent sx={{ pt: 2, display: 'flex', flexDirection: 'column', gap: 2 }}>
          {usuarioCriado && <Alert severity="success">Usuário criado com sucesso. Esta janela será fechada automaticamente.</Alert>}
          <Typography variant="body2" color="text.secondary">
            Os dados cadastrais do colaborador serão usados para criar e vincular o usuário de acesso.
          </Typography>
          <TextField label="Colaborador" value={colaboradorParaUsuario?.nome_completo || ''} disabled fullWidth />
          <TextField label="E-mail de acesso" value={colaboradorParaUsuario?.email || ''} disabled fullWidth />
          <FormControl fullWidth required>
            <InputLabel id="perfil-usuario-colaborador">Perfil de Gestão</InputLabel>
            <Select labelId="perfil-usuario-colaborador" label="Perfil de Gestão" value={profileIdUsuario} onChange={(event) => setProfileIdUsuario(event.target.value)} disabled={criandoUsuario || !perfisAtivos.length}>
              {perfisAtivos.map((perfil) => <MenuItem key={perfil.id} value={perfil.id}>{perfil.nome}</MenuItem>)}
            </Select>
          </FormControl>
          <TextField label="Senha inicial" type="password" value={senhaUsuario} onChange={(event) => setSenhaUsuario(event.target.value)} fullWidth disabled={criandoUsuario || usuarioCriado || Boolean(colaboradorParaUsuario?.id_usuario)} helperText={colaboradorParaUsuario?.id_usuario ? 'Para um usuário já vinculado, a senha atual será preservada.' : 'A senha pode ser alterada pelo usuário posteriormente.'} />
        </DialogContent>
        <DialogActions>
          <Button onClick={fecharCriarUsuario} disabled={criandoUsuario}>Cancelar</Button>
          <Button variant="contained" startIcon={criandoUsuario ? <CircularProgress size={18} color="inherit" /> : <PersonAddIcon />} onClick={criarUsuarioParaColaborador} disabled={criandoUsuario || usuarioCriado || !profileIdUsuario || !perfisAtivos.length}>
            {usuarioCriado ? 'USUÁRIO CRIADO' : colaboradorParaUsuario?.id_usuario ? 'ATIVAR E VINCULAR' : 'CRIAR USUÁRIO'}
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={openView}
        onClose={fecharVisualizacao}
        maxWidth={false}
        fullWidth={false}
        disableEscapeKeyDown
        disableBackdropClick
        disablePortal
        hideBackdrop={false}
        sx={{
          '& .MuiDialog-backdrop': {
            backgroundColor: 'rgba(0, 0, 0, 0.8)'
          }
        }}
        PaperProps={{
          sx: {
            width: { xs: '95vw', sm: '90vw', md: '900px' },
            height: { xs: '95vh', sm: '90vh', md: '550px' },
            maxWidth: { xs: '95vw', sm: '90vw', md: '900px' },
            maxHeight: { xs: '95vh', sm: '90vh', md: '550px' },
            position: 'relative',
            margin: { xs: 'auto', sm: 'auto', md: 'auto' }
          }
        }}
      >
        <DialogTitle sx={{ 
          backgroundColor: (theme) => theme.palette.mode === 'dark' ? '#1B5E20' : '#E0F8E0',
          borderBottom: 1,
          borderColor: 'divider',
          padding: 2,
          fontSize: '1.25rem',
          fontWeight: 500
        }}>
          Visualizar Colaborador
        </DialogTitle>

        <DialogContent sx={{ 
          height: { xs: 'calc(100% - 120px)', sm: 'calc(100% - 140px)' },
          overflow: 'auto',
          padding: { xs: 1, sm: 2 },
          '&.MuiDialogContent-root': {
            paddingTop: { xs: 1, sm: 2 }
          },
          position: 'relative',
          top: 0,
          marginBottom: { xs: '60px', sm: '60px' },
          '& .MuiInputLabel-root': {
            fontSize: '0.875rem'
          },
          '& .MuiInputBase-input': {
            fontSize: '0.875rem'
          },
          '& .MuiFormControlLabel-label': {
            fontSize: '0.875rem'
          }
        }}>
          <Tabs 
            value={activeTab} 
            onChange={handleTabChange}
            sx={{
              borderBottom: 1,
              borderColor: 'divider',
              mb: 2
            }}
          >
            <Tab label="Dados Pessoais" />
              <Tab label="Endereço" />
            <Tab label="Contato" />
              <Tab label="Dados Profissionais" />
            <Tab label="Outros" />
          </Tabs>

          {activeTab === 0 && (
            <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
              <Box>
                <TextField 
                  fullWidth 
                  label="Nome Completo" 
                  value={colaboradorVisualizar?.nome_completo || ""}
                  disabled
                />
              </Box>
              <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap' }}>
                <Box sx={{ flex: '1 1 200px' }}>
                  <TextField
                    fullWidth
                    label="CPF"
                    value={colaboradorVisualizar?.cpf ? formatarCPFCNPJLGPD(colaboradorVisualizar.cpf, "Física", true) : ""}
                    disabled
                  />
                </Box>
                <Box sx={{ flex: '1 1 200px' }}>
                  <TextField
                    fullWidth
                    label="Data de Nascimento"
                    value={colaboradorVisualizar?.data_nascimento || ""}
                    disabled
                  />
                </Box>
                <Box sx={{ flex: '1 1 200px' }}>
                  <TextField
                    fullWidth
                    label="Gênero"
                    value={colaboradorVisualizar?.genero || ""}
                    select
                    disabled
                  >
                    {GENERO_OPTIONS.map((option) => (
                      <MenuItem key={option.value} value={option.value}>
                        {option.label}
                      </MenuItem>
                    ))}
                  </TextField>
                </Box>
              </Box>
              <Box>
                <TextField
                  fullWidth
                  label="Estado Civil"
                  value={colaboradorVisualizar?.estado_civil || ""}
                  select
                  disabled
                >
                  <MenuItem value="">Selecione...</MenuItem>
                  {ESTADO_CIVIL_OPTIONS.map((option) => (
                    <MenuItem key={option.value} value={option.value}>
                      {option.label}
                    </MenuItem>
                  ))}
                </TextField>
              </Box>
            </Box>
          )}

          {activeTab === 1 && (
            <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
              <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap' }}>
                <Box sx={{ flex: '1 1 300px' }}>
                  <TextField
                    fullWidth
                    label="CEP"
                    value={colaboradorVisualizar?.cep || ""}
                    disabled
                  />
                </Box>
                <Box sx={{ flex: '1 1 300px' }}>
                  <TextField
                    fullWidth
                    label="Endereço"
                    value={colaboradorVisualizar?.logradouro || ""}
                    disabled
                  />
                </Box>
              </Box>
              <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap' }}>
                <Box sx={{ flex: '1 1 300px' }}>
                  <TextField
                    fullWidth
                    label="Número"
                    value={colaboradorVisualizar?.numero || ""}
                    disabled
                  />
                </Box>
                <Box sx={{ flex: '1 1 300px' }}>
                  <TextField
                    fullWidth
                    label="Complemento"
                    value={colaboradorVisualizar?.complemento || ""}
                    disabled
                  />
                </Box>
              </Box>
              <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap' }}>
                <Box sx={{ flex: '1 1 300px' }}>
                  <TextField
                    fullWidth
                    label="Bairro"
                    value={colaboradorVisualizar?.bairro || ""}
                    disabled
                  />
                </Box>
                <Box sx={{ flex: '1 1 300px' }}>
                  <TextField
                    fullWidth
                    label="Cidade"
                    value={colaboradorVisualizar?.cidade || ""}
                    disabled
                  />
                </Box>
              </Box>
              <Box>
                <TextField
                  fullWidth
                  label="Estado"
                  value={colaboradorVisualizar?.estado || ""}
                  select
                  disabled
                >
                  <MenuItem value="AC">Acre</MenuItem>
                  <MenuItem value="AL">Alagoas</MenuItem>
                  <MenuItem value="AP">Amapá</MenuItem>
                  <MenuItem value="AM">Amazonas</MenuItem>
                  <MenuItem value="BA">Bahia</MenuItem>
                  <MenuItem value="CE">Ceará</MenuItem>
                  <MenuItem value="DF">Distrito Federal</MenuItem>
                  <MenuItem value="ES">Espírito Santo</MenuItem>
                  <MenuItem value="GO">Goiás</MenuItem>
                  <MenuItem value="MA">Maranhão</MenuItem>
                  <MenuItem value="MT">Mato Grosso</MenuItem>
                  <MenuItem value="MS">Mato Grosso do Sul</MenuItem>
                  <MenuItem value="MG">Minas Gerais</MenuItem>
                  <MenuItem value="PA">Pará</MenuItem>
                  <MenuItem value="PB">Paraíba</MenuItem>
                  <MenuItem value="PR">Paraná</MenuItem>
                  <MenuItem value="PE">Pernambuco</MenuItem>
                  <MenuItem value="PI">Piauí</MenuItem>
                  <MenuItem value="RJ">Rio de Janeiro</MenuItem>
                  <MenuItem value="RN">Rio Grande do Norte</MenuItem>
                  <MenuItem value="RS">Rio Grande do Sul</MenuItem>
                  <MenuItem value="RO">Rondônia</MenuItem>
                  <MenuItem value="RR">Roraima</MenuItem>
                  <MenuItem value="SC">Santa Catarina</MenuItem>
                  <MenuItem value="SP">São Paulo</MenuItem>
                  <MenuItem value="SE">Sergipe</MenuItem>
                  <MenuItem value="TO">Tocantins</MenuItem>
                </TextField>
              </Box>
            </Box>
          )}

          {activeTab === 2 && (
            <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
              <Box>
                <TextField
                  fullWidth
                  label="Email"
                  value={colaboradorVisualizar?.email ? formatarEmailLGPD(colaboradorVisualizar.email, true) : ""}
                  disabled
                />
              </Box>
              <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap' }}>
                <Box sx={{ flex: '1 1 300px' }}>
                  <TextField
                    fullWidth
                    label="Telefone Fixo"
                    value={colaboradorVisualizar?.telefone_fixo ? formatarTelefoneLGPD(colaboradorVisualizar.telefone_fixo, true) : ""}
                    disabled
                  />
                </Box>
                <Box sx={{ flex: '1 1 300px' }}>
                  <TextField
                    fullWidth
                    label="Celular"
                    value={colaboradorVisualizar?.celular ? formatarTelefoneLGPD(colaboradorVisualizar.celular, true) : ""}
                    disabled
                  />
                </Box>
              </Box>
            </Box>
          )}

          {activeTab === 3 && (
            <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
              <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap' }}>
                <Box sx={{ flex: '1 1 300px' }}>
                  <TextField 
                    fullWidth 
                    label="Cargo" 
                    value={colaboradorVisualizar?.cargo || ""}
                    disabled
                  />
                </Box>
                <Box sx={{ flex: '1 1 300px' }}>
                  <TextField 
                    fullWidth 
                    label="Departamento" 
                    value={colaboradorVisualizar?.departamento || ""}
                    disabled
                  />
                </Box>
                <Box sx={{ flex: '1 1 300px' }}>
                  <TextField
                    fullWidth
                    label="Registro profissional"
                    value={colaboradorVisualizar?.registro_profissional || ""}
                    disabled
                  />
                </Box>
              </Box>
              <Box>
                <TextField 
                  fullWidth 
                  label="Salário" 
                  value={colaboradorVisualizar?.salario ? `R$ ${parseFloat(colaboradorVisualizar.salario).toFixed(2)}` : ""}
                  disabled
                />
              </Box>
              <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap' }}>
                <Box sx={{ flex: '1 1 300px' }}>
                  <TextField
                    fullWidth
                    label="Data de Admissão"
                    value={colaboradorVisualizar?.data_admissao || ""}
                    disabled
                  />
                </Box>
                <Box sx={{ flex: '1 1 300px' }}>
                  <TextField
                    fullWidth
                    label="Data de Demissão"
                    value={colaboradorVisualizar?.data_demissao || ""}
                    disabled
                  />
                </Box>
              </Box>
            </Box>
          )}


          {activeTab === 4 && (
            <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
              <Box>
                <TextField 
                  fullWidth 
                  label="Observações" 
                  value={colaboradorVisualizar?.observacoes || ""}
                  disabled
                  multiline 
                  rows={4}
                />
              </Box>
              <Box>
                <FormControlLabel
                  control={
                    <Switch
                      checked={colaboradorVisualizar?.status === STATUS_OPTIONS[0].value}
                      disabled
                    />
                  }
                  label={STATUS_OPTIONS[0].label}
                />
              </Box>
              <Box>
                <FormControlLabel
                  control={
                    <Switch
                      checked={colaboradorVisualizar?.tem_empresa}
                      disabled
                    />
                  }
                  label="Tem empresa aberta?"
                />
              </Box>
              {colaboradorVisualizar?.tem_empresa && (
                <Box sx={{ display: 'flex', gap: 2 }}>
                  <Box sx={{ flex: 1 }}>
                    <FormControl fullWidth>
                      <InputLabel shrink>Tipo de Pessoa Jurídica</InputLabel>
                      <Select 
                        value={colaboradorVisualizar?.tipo_pessoa_juridica || ""}
                        disabled
                        label="Tipo de Pessoa Jurídica"
                      >
                        <MenuItem value="">Selecione...</MenuItem>
                        <MenuItem value="MEI">MEI</MenuItem>
                        <MenuItem value="ME">ME</MenuItem>
                        <MenuItem value="EPP">EPP</MenuItem>
                        <MenuItem value="LTDA">LTDA</MenuItem>
                        <MenuItem value="SA">SA</MenuItem>
                      </Select>
                    </FormControl>
                  </Box>
                  <Box sx={{ flex: 1 }}>
                    <TextField
                      fullWidth
                      label="CNPJ"
                      value={colaboradorVisualizar?.cnpj ? formatarCPFCNPJLGPD(colaboradorVisualizar.cnpj, "Jurídica", true) : ""}
                      disabled
                    />
                  </Box>
                </Box>
              )}
            </Box>
          )}
        </DialogContent>

        <DialogActions sx={{ 
          position: 'absolute',
          bottom: 0,
          left: 0,
          right: 0,
          padding: { xs: 1, sm: 2 },
          backgroundColor: (theme) => theme.palette.mode === 'dark' ? theme.palette.success.dark : theme.palette.success.light,
          borderTop: 1,
          borderColor: 'divider',
          zIndex: 1,
          height: { xs: '60px', sm: '60px' },
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          flexDirection: { xs: 'column', sm: 'row' },
          gap: { xs: 1, sm: 0 },
          '& .MuiButton-root': {
            fontSize: { xs: '0.75rem', sm: '0.875rem' },
            textTransform: 'uppercase',
            fontWeight: 500,
            minWidth: { xs: 'auto', sm: 'auto' }
          },
          '& .MuiTypography-root': {
            fontSize: { xs: '0.75rem', sm: '0.875rem' }
          }
        }}>
          <Typography variant="body2" color="text.secondary">
            {formatarDataHora(dataHoraAtual)}
          </Typography>
          <Box sx={{ 
            display: 'flex', 
            gap: { xs: 0.5, sm: 1 },
            flexWrap: { xs: 'wrap', sm: 'nowrap' },
            justifyContent: { xs: 'center', sm: 'flex-end' }
          }}>
            <Button
              variant="outlined"
              onClick={() => setActiveTab(prev => Math.max(0, prev - 1))}
              disabled={activeTab === 0}
              size={window.innerWidth < 600 ? "small" : "medium"}
            >
              Anterior
            </Button>
            <Button
              variant="outlined"
              onClick={() => setActiveTab(prev => Math.min(5, prev + 1))}
              disabled={activeTab === 5}
              size={window.innerWidth < 600 ? "small" : "medium"}
            >
              Próximo
            </Button>
            <Button
              variant="contained"
              onClick={fecharVisualizacao}
              size={window.innerWidth < 600 ? "small" : "medium"}
              sx={{
                backgroundColor: (theme) => theme.palette.mode === 'dark' 
                  ? '#ffffff' 
                  : theme.palette.primary.main,
                color: (theme) => theme.palette.mode === 'dark' 
                  ? '#000000' 
                  : theme.palette.primary.contrastText,
                '&:hover': {
                  backgroundColor: (theme) => theme.palette.mode === 'dark' 
                    ? '#f5f5f5' 
                    : theme.palette.primary.dark,
                }
              }}
            >
              FECHAR
            </Button>
            <Button
              variant="contained"
              onClick={() => imprimirColaborador(colaboradorVisualizar)}
              startIcon={<PrintIcon />}
              size={window.innerWidth < 600 ? "small" : "medium"}
              sx={{
                backgroundColor: (theme) => theme.palette.mode === 'dark' 
                  ? '#ffffff' 
                  : theme.palette.primary.main,
                color: (theme) => theme.palette.mode === 'dark' 
                  ? '#000000' 
                  : theme.palette.primary.contrastText,
                '&:hover': {
                  backgroundColor: (theme) => theme.palette.mode === 'dark' 
                    ? '#f5f5f5' 
                    : theme.palette.primary.dark,
                }
              }}
            >
              IMPRIMIR
            </Button>
          </Box>
        </DialogActions>
      </Dialog>
      </Box> {/* Fechamento do Box interno com margens de 1,5% */}
    </Box>
    </AcessoRestrito>
  );
}
